<template>
  <div :class="$style.videoPlayer">
    <div :class="$style.wrap">
      <audio ref="audio" :class="$style.audio"></audio>
      <CD :class="$style.cd" />
      <div :class="$style.fileName">{{fileName}}</div>

      <div :class="$style.controller">
        <div :class="$style.playLoading" v-if="audioLoading">
          <i class="el-icon-loading"></i>
        </div>
        <span v-else @click="play" :class="[$style.playControl, playing ? $style.pauseBtn : $style.playBtn]"></span>
        <ProgressBar @onSeek="onSeek" :class="$style.progressBar" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CD from './CD'
import ProgressBar from './ProgressBar'
import Emitter from 'element-ui/lib/mixins/emitter'
import { SupportAudioType } from '@/utils/format'
import {errorCodeMap} from '@/utils/errorcodes.js'

let updateTimeStamp = 0
let reloadTimeStamp = 0
// 记录错误重加载次数
let reloadCount = 0

export default {
  name: 'AudioPlayer',
  components: { CD, ProgressBar },
  props: {
    options: Object
  },
  mixins: [Emitter],
  computed: {
    ...mapState(['playing', 'audioLoading', 'duration', 'currentTime', 'muted', 'fileInfo']),
    fileName () {
      let filename = ''
      if (this.fileInfo) {
        filename = this.fileInfo.fname.split('.').slice(0, -1).join('.')
      }
      return filename
    }
  },
  watch: {
    playing () {
      if (this.playing) {
        this.$refs.audio.play()
      } else {
        this.$refs.audio.pause()
      }
    }
  },
  mounted () {
    this.initAudio()
    reloadTimeStamp = 0
    this.$refs.audio.currentTime = 0
  },
  methods: {
    setAudioSrc(audio) {
      let sources = ''
      const stamp = Date.now()
      Array.prototype.forEach.call(SupportAudioType, t => {
        let source = document.createElement('source')
        source.src = `${this.options.url}?stamp=${stamp}`
        source.type = `audio/${t}`
        sources += source.outerHTML
      })
      audio.innerHTML = sources
    },
    initAudio () {
      const self = this
      const audio = this.$refs.audio
      const extName = (this.fileInfo.fname.split('.').reverse()[0]).toLowerCase()

      // 查询文件是否支持播放
      if (!audio.canPlayType(`audio/${extName}`)) {
        this.dispatch('APP', 'showError', { info: { code: errorCodeMap.FILETYPE_NOT_SUPPORT } })
        return
      }
      audio.volume = 0.5
      this.$store.commit('SET_MUTE_STATUS', audio.defaultMuted)

      // 根据文件后缀添加audioType
      if (this.options && this.options.url) {
        this.setAudioSrc(audio)

        // audio.src = this.options.url
        audio.onloadedmetadata = () => {
          this.dispatch('APP', 'dwReporter',{
            page: 'preview',
            operation: 'show'
          })
          function tryDruation () {
            setTimeout(() => {
              if (audio.duration <= 0) {
                tryDruation()
              } else {
                self.$store.commit('SET_MEDIA_DURATION', audio.duration)
              }
            }, 100)
          }
          if (audio.duration <= 0) {
            tryDruation()
          }
          // 如果加载成功，不算入reload，归零
          reloadCount = 0
          // 存在 reloadTimeStamp 时，说明是重新加载的音频, 只需要更新当前进度条
          if (reloadTimeStamp) {
            this.$refs.audio.currentTime = reloadTimeStamp // 在元数据加载完成后设置
          } else {
            this.$store.commit('SET_MEDIA_DURATION', audio.duration)
            this.$DwManager.recordTotalTime(audio.duration)
            this.$DwManager.reportShowAction('audio', { fileInfo: this.fileInfo, mediaInfo: { duration: audio.duration } })
          }
        }
        audio.ontimeupdate = () => {
          // 记录最新的播放时间
          updateTimeStamp = audio.currentTime
          this.$store.commit('SET_MEDIA_CURRENT_TIME', audio.currentTime)
        }
        audio.onended = () => {
          this.$store.commit('SET_PLAY_STATUS', !this.$refs.audio.paused)
          this.$DwManager.recordPlayTime('ended')

          // 还原配置，立马还原配置（用异步的方式）
          setTimeout(() => {
            reloadCount = 0
            reloadTimeStamp = 0
            updateTimeStamp = 0
          }, 10)
        }
        audio.onerror = () => {
           /**
           * 报错后，如果检测到是文件资源加载相关的报错
           * 重新加载音频源，并从记录的播放时间开始播放
           * 记录错误重加载次数，如果相关错误次数大于3次，则不再重新加载
           */
          if (audio.error && audio.error.code === 2 && reloadCount < 3) {
            // 发生错误，更新错误时间，避免污染
            reloadTimeStamp = updateTimeStamp
            reloadCount++
            this.mediaReload()
          } else {
            // 遇到奇怪的错误
            console.error('Audio error: ', e)
            this.dispatch('APP', 'showError', { info: { code: errorCodeMap.FILETYPE_NOT_SUPPORT } })
            this.$DwManager.recordInitialPlayStatus(audio.error.code)
          }
        }
        audio.onemptied = () => {
          // TODO 发生故障并且文件突然不可用，比如连接意外断开时
        }

        // dw start
        audio.oncanplaythrough = () => {
          this.$DwManager.measureFileLoaded('end')
        }
        audio.onloadstart = () => {
          this.$DwManager.measureFileLoaded('start')
          this.$DwManager.measureFirstFrameLoaded('start')
        }
        audio.onloadeddata = () => {
          this.$DwManager.measureFirstFrameLoaded('end')
        }
        audio.onwaiting = () => {
          // TODO 缓冲中
          this.$DwManager.measureFirstTimeBuffering('start')
        }
        audio.onplaying = () => {
          this.$DwManager.measureFirstTimeBuffering('end')
        }
        audio.onseeked = () => {
          this.$DwManager.reportUserActiveAction('seeking', 'audio')
        }
        audio.onplay = () => {
          this.$DwManager.reportUserActiveAction('play', 'audio')
          this.$DwManager.recordPlayTime('play')
        }
        audio.onpause = () => {
          this.$DwManager.reportUserActiveAction('pause', 'audio')
          this.$DwManager.recordPlayTime('pause')
        }
        audio.onvolumechange = () => {
          this.$DwManager.reportUserActiveAction('volumechange', 'audio')
        }
        // dw end
      }
    },
    play () {
      if (this.$refs.audio.paused) {
        this.$refs.audio.play()
      } else {
        this.$refs.audio.pause()
      }
      this.$store.commit('SET_PLAY_STATUS', !this.$refs.audio.paused)
      this.dispatch('APP', 'dwReporter',{
        page: 'preview',
        operation: 'play',
        play_time: this.$refs.audio.currentTime.toFixed(2)
      })
    },
    // 重新加载音频资源
    mediaReload() {
      const audio = this.$refs.audio
      this.$store.commit('SET_AUDIO_LOADING', true)
      audio.innerHTML = ''
      this.setAudioSrc(audio)

      // 重新加载音频资源
      audio.load()
      audio.onloadeddata = () => {
        this.$store.commit('SET_AUDIO_LOADING', false)
        this.$refs.audio.play()
      }
    },
    onSeek (val) {
      this.$refs.audio.currentTime = val
    }
  }
}
</script>

<style lang="scss" module>
.videoPlayer {
  width: 100%;
  background: #fff;
  position: relative;
}

.wrap {
  padding: 14px 20px;
}

.audio {
  display: none;
}

.cd {
  margin: auto;
  height: 285px;
  background-position: 50% 100%;

  & > div {
    width: 208px;
    height: 208px;
  }
}

.fileName {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #3D4757;
  line-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.controller {
  display: flex;
  margin-top: 32px;
}

.playControl {
  width: 58px;
  height: 58px;
  margin-right: 8px;
  align-items: center;
  cursor: pointer;
}

.playLoading {
  width: 58px;
  height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #AEB5C0;
}

.progressBar {
  flex: 1;
}

.pauseBtn {
  background-image: url('./assets/pause_btn.svg');
}

.playBtn {
  background-image: url('./assets/play_btn.svg');
}

.play {
  cursor: pointer;
  user-select: none;
}
</style>
